"use strict";

/**
 * Central list of audiobook voices. Each entry describes the provider, the
 * provider specific id, the display name and gender.  The `special` flag marks
 * voices that should also appear in the "Special Voices" section of select
 * menus.
 */
export const AUDIOBOOK_VOICES = [
    { provider: "elevenlabs", id: "TJdGgFoRwIpDGaLZCRzq", name: "Marcus", gender: "M" },
    { provider: "elevenlabs", id: "MWzURibm2jQVREQlGp7y", name: "Alex", gender: "M" },
    { provider: "elevenlabs", id: "mUVoHLBTFzjOr0eQsoFX", name: "Neal", gender: "M" },
    { provider: "elevenlabs", id: "EiNlNiXeDU1pqqOPrYMO", name: "John", gender: "M" },
    { provider: "elevenlabs", id: "uju3wxzG5OhpWcoi3SMy", name: "Michael", gender: "M" },
    { provider: "elevenlabs", id: "NFG5qt843uXKj4pFvR7C", name: "Adam", gender: "M" },
    { provider: "elevenlabs", id: "XjLkpWUlnhS8i7gGz3lZ", name: "David", gender: "M" },
    { provider: "elevenlabs", id: "Mu5jxyqZOLIGltFpfalg", name: "Jameson", gender: "M" },
    { provider: "elevenlabs", id: "e5WNhrdI30aXpS2RSGm1", name: "Ian", gender: "M" },
    { provider: "elevenlabs", id: "GqSKXqyx5UloX8k3fdM7", name: "Bria", gender: "F" },
    { provider: "elevenlabs", id: "lxYfHSkYm1EzQzGhdbfc", name: "Jessica", gender: "F" },
    { provider: "elevenlabs", id: "ZqTgRkmbVg1mWhJwYVEe", name: "Maya", gender: "F" },
    { provider: "elevenlabs", id: "i4CzbCVWoqvD0P1QJCUL", name: "Ivy", gender: "F" },
    { provider: "elevenlabs", id: "5l5f8iK3YPeGga21rQIX", name: "Adeline", gender: "F" },
    { provider: "elevenlabs", id: "rCmVtv8cYU60uhlsOo1M", name: "Ana", gender: "F" },
    { provider: "elevenlabs", id: "NvvkRbxCrZ6F7iA9pBY5", name: "Sara", gender: "F", special: true },
    { provider: "elevenlabs", id: "tnSpp4vdxKPjI9w0GnoV", name: "Hope", gender: "F" },
    { provider: "elevenlabs", id: "ZF6FPAbjXT4488VcRRnw", name: "Amelia", gender: "F" },
    { provider: "elevenlabs", id: "P7x743VjyZEOihNNygQ9", name: "Dakota", gender: "F" },
    { provider: "custom", id: "Male_audiobook_1", name: "James", gender: "M" },
    { provider: "custom", id: "Male_audiobook_2", name: "Robert", gender: "M" },
    { provider: "custom", id: "Male_audiobook_3", name: "William", gender: "M" },
    { provider: "custom", id: "Female_audiobook_1", name: "Emma", gender: "F" },
    { provider: "custom", id: "Female_audiobook_2", name: "Sophia", gender: "F" },
    { provider: "custom", id: "Female_audiobook_3", name: "Olivia", gender: "F" }
];

export const ELEVENLABS_VOICES = AUDIOBOOK_VOICES.filter(
    (voice) => voice.provider === "elevenlabs"
);

export const CUSTOM_MODEL_VOICES = AUDIOBOOK_VOICES.filter(
    (voice) => voice.provider === "custom"
);

export const SPECIAL_VOICES = AUDIOBOOK_VOICES.filter((voice) => voice.special);

// Map voice identifiers to human readable names.  For ElevenLabs voices we
// support both the raw id and the "provider:id" format to match existing usage
// across the codebase.
export const AUDIOBOOK_VOICE_NAME_MAP = AUDIOBOOK_VOICES.reduce(
    (acc, voice) => {
        const key = `${voice.provider}:${voice.id}`;
        acc[key] = voice.name;
        if (voice.provider === "elevenlabs") {
            acc[voice.id] = voice.name;
        }
        return acc;
    },
    {}
);

